module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.f5331cb6.ttf";